module.exports = __webpack_public_path__ + "img/visorUser.102d4afd.svg";